"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VirtualizedOptions = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_virtuoso_1 = require("react-virtuoso");
const LoadingDots_1 = require("./LoadingDots");
const Option_1 = require("./Option");
const TreeOption_1 = require("../TreeSelectField/TreeOption");
const utils_1 = require("../TreeSelectField/utils");
// Displays ListBox options in a virtualized container for performance reasons
function VirtualizedOptions(props) {
    const { state, items, onListHeightChange, contrast, scrollOnFocus, loading, disabledOptionsWithReasons, isTree, allowCollapsing, } = props;
    const virtuosoRef = (0, react_1.useRef)(null);
    const focusedItem = state.collection.getItem(state.selectionManager.focusedKey);
    const selectedItem = state.selectionManager.selectedKeys.size > 0
        ? state.collection.getItem([...state.selectionManager.selectedKeys.values()][0])
        : undefined;
    // Handle scrolling to the item in focus when navigating options via Keyboard - this should only be applied when using a "virtual focus", such as a ComboBox where the browser's focus remains in the <input /> element.
    (0, react_1.useEffect)(() => {
        if (scrollOnFocus && virtuosoRef.current && (focusedItem === null || focusedItem === void 0 ? void 0 : focusedItem.index)) {
            virtuosoRef.current.scrollToIndex({ index: focusedItem.index, align: "center" });
        }
    }, 
    // TODO: validate this eslint-disable. It was automatically ignored as part of https://app.shortcut.com/homebound-team/story/40033/enable-react-hooks-exhaustive-deps-for-react-projects
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [focusedItem]);
    return ((0, jsx_runtime_1.jsx)(react_virtuoso_1.Virtuoso, { ref: virtuosoRef, totalListHeightChanged: onListHeightChange, totalCount: items.length, ...(process.env.NODE_ENV === "test"
            ? {
                // We don't really need to set this, but it's handy for tests, which would
                // otherwise render just 1 row. A better way to do this would be to jest.mock
                // out Virtuoso with an impl that just rendered everything, but doing this for now.
                initialItemCount: items.length,
                key: items.length,
            }
            : {
                // Ensure the selected item is visible when the list renders
                // This seems to break tests, so only add in the non-test environment.
                initialTopMostItemIndex: selectedItem ? selectedItem.index : 0,
            }), itemContent: (idx) => {
            var _a;
            const item = items[idx];
            if (item) {
                if (isTree && (0, utils_1.isLeveledNode)(item)) {
                    return ((0, jsx_runtime_1.jsx)(TreeOption_1.TreeOption, { item: item, state: state, contrast: contrast, 
                        // scrollToIndex={scrollOnFocus ? undefined : virtuosoRef.current?.scrollToIndex}
                        allowCollapsing: allowCollapsing }, item.key));
                }
                if (!(0, utils_1.isLeveledNode)(item)) {
                    return ((0, jsx_runtime_1.jsx)(Option_1.Option, { item: item, state: state, contrast: contrast, 
                        // Only send scrollToIndex functionality forward if we are not auto-scrolling on focus.
                        scrollToIndex: scrollOnFocus ? undefined : (_a = virtuosoRef.current) === null || _a === void 0 ? void 0 : _a.scrollToIndex, disabledReason: disabledOptionsWithReasons[item.key] }, item.key));
                }
            }
        }, components: !loading
            ? {}
            : {
                Footer: typeof loading === "function" ? loading : () => (0, jsx_runtime_1.jsx)(LoadingDots_1.LoadingDots, { contrast: contrast }),
            } }));
}
exports.VirtualizedOptions = VirtualizedOptions;
